module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjkiIHZpZXdCb3g9IjAgMCAxMiA5IiB3aWR0aD0iMTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTExLjAxMDc1MjcgMC03LjA3NTI2ODgzIDcuMDUtMi45NDYyMzY1Ni0yLjkzNTcxNDI5LS45ODkyNDczMS45ODU3MTQyOSAzLjQ0MDg2MDIyIDMuNDI4NTcxNDMuNDk0NjIzNjUuNDcxNDI4NTcuNDk0NjIzNjYtLjQ3MTQyODU3IDcuNTY5ODkyNDctNy41NDI4NTcxNHoiIGZpbGw9IiMwMDczQzIiIHRyYW5zZm9ybT0iIi8+PC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ../core/src/assets/images/global-checkmark.svg
// module id = 273
// module chunks = 0